module.exports = __webpack_public_path__ + "img/bg_vocabulary_04.5c0042f9.jpg";